export default [
  {
    path: '/usuarios',
    name: 'Painel Usuários',
    meta: { layout: 'default' },
    component: () => import('@/views/Usuarios/usuarios.vue'),
  }
];
